@if (number < 100) {
  <div [attr.aria-label]="label">
    {{ number }}
  </div>
} @else {
  <small [attr.aria-label]="label" class="text-xs">99+</small>
}
